import * as errorActions from 'actions/error';

const initialState = {
  message: null,
};

const errorReducer = (state = initialState, action) => {
  switch (action.type) {
    case errorActions.SET_ERROR:
      return { ...state, ...action.payload };
    default:
      return state;
  }
};

export default errorReducer;



// WEBPACK FOOTER //
// ./src/reducers/error/index.js